import React from "react";
import { Button } from "@my-scoot/component-library-legacy";
import Lock from "@material-ui/icons/Lock";
import { openPricingPage } from "utils/Utils";
import classnames from "classnames";

export const LockButton = ({
  text = "Locked",
  onClick,
  textClasses = "",
  lockClasses = "",
  buttonClasses = "",
}) => {
  return (
    <>
      <Button
        className={classnames(
          "!tw-text-black !tw-bg-[linear-gradient(124.63deg,#FFD37E_3.13%,#F7AD1E_106.11%)] !tw-p-4 !tw-border-none",
          buttonClasses
        )}
        onClick={onClick ? onClick : openPricingPage}
      >
        <Lock
          className={classnames(`tw-text-black tw-mr-2`, lockClasses)}
          fontSize="small"
        />
        <div className={textClasses}>{text}</div>
      </Button>
    </>
  );
};
